import Http from '@/utils/http';
import Cookies from 'js-cookie';
import { baseOrigin } from '@/config/env';
const baseUrl = `${baseOrigin}/positions`;
const baseUrl1 = `${baseOrigin}/positionTypes`;

async function getAdvertiseList(params) {
    return Http.get(baseUrl + '/page', { params, headers: {'Token': Cookies.get('token')}});
}

async function getAllAdvertise(params) {
    return Http.get(baseUrl, { params, headers: {'Token': Cookies.get('token')}});
}

async function createAdvertise(data) {
    return Http.post(baseUrl, data, { headers: {'Token': Cookies.get('token')} });
}

async function getAdvertise(id) {
    return Http.get(`${baseUrl}/${id}`, { headers: {'Token': Cookies.get('token')}});
}

async function modifyAdvertise(data) {
    return Http.put(baseUrl, data, { headers: {'Token': Cookies.get('token')} });
}

async function deleteAdvertise(id) {
    return Http.delete(`${baseUrl}/${id}`, { headers: {'Token': Cookies.get('token')} })
}
/*获取密钥*/
async function getSecret(params) {
     return Http.get(baseUrl+'/secret', { params, headers: {'Token': Cookies.get('token')}});
}
/*获取用户所有广告位*/
async function getAdvertiseSimpleList(params) {
    return Http.get(baseUrl+'/list', { params, headers: {'Token': Cookies.get('token')}});
}

/*获取广告位*/
async function getAdvertiseTypeList(params) {
    return Http.get(baseUrl1+'/list', { params, headers: {'Token': Cookies.get('token')}});
}
export {
    getAdvertiseList,
    getAllAdvertise,
    createAdvertise,
    getAdvertise,
    modifyAdvertise,
    deleteAdvertise,
    getSecret,
    getAdvertiseSimpleList,
    getAdvertiseTypeList
};
